module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0085.jpg?v=3447c7e4";